import { ObservableMap } from "mobx";
import { MenuItem } from "primereact/menuitem";

export enum AdminSettingsTabType {
  /** Inherited by the others */
  general = "general",

  /** Iframe */
  embed = "embed",

  /** cv.webtemp.no */
  cvWebtempNo = "cvWebtempNo",

  textAndTranslations = "textAndTranslations",
}

export interface AdminSettingsTab extends MenuItem {
  key: string;
  label: string;
  header: any;
  icon?: string;
  type: AdminSettingsTabType;
  idEmbed: string;
  asiUnsavedChanges: ObservableMap<string, any>;
}
